import styled from "styled-components";

const PopWrap = styled.div`
   position: absolute;
   top: calc(100% + 8px);
   left: 0;
   width: 260px;
   background: #ffffff;
   border: 1px solid #EDEDEE;
   border-radius: 10px;
   box-shadow: 0px 4px 6px -2px rgba(16,24,40,0.04);
   display: flex;
   flex-direction: column;
   overflow: hidden;
   z-index: 30;
`;

const SearchBar = styled.div`
   display: flex;
   align-items: center;
   gap: 10px;
   padding: 10px 16px;
   border-bottom: 1px solid #F5F5F6;
`;

const SearchInput = styled.input`
   flex: 1;
   background: transparent;
   border: none;
   outline: none;
   font-size: 13px;
   color: #101018;
   &::placeholder { color: #B3B3B6; }
`;

const SectionBlock = styled.div`
   display: flex;
   flex-direction: column;
   gap: 6px;
   padding: 0 16px 12px;
   border-bottom: 1px solid #F5F5F6;
   &:last-of-type { border-bottom: none; }
`;

const SectionTitle = styled.div`
   padding: 7px 0 3px;
   font-size: 12px;
   letter-spacing: -0.025em;
   color: #9C9C9F;
   font-weight: 400;
`;

const OptionRow = styled.label`
   display: inline-flex;
   align-items: center;
   gap: 10px;
   background: #FFFFFF;
   border-radius: 8px;
   padding: 7px 8px;
   cursor: pointer;
   font-size: 14px;
   letter-spacing: -0.025em;
   color: #101018;
   user-select: none;
   transition: background .16s;
   &:hover { background: #F9F9FA; }
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
   opacity: 0;
   position: absolute;
   pointer-events: none;
`;

const Box = styled.span<{ $checked?: boolean }>`
   width: 14px;
   height: 14px;
   border-radius: 4px;
   border: 1px solid ${p => p.$checked ? '#C02236' : '#E2E2E3'};
   background: ${p => p.$checked ? '#C02236' : '#FFFFFF'};
   position: relative;
   display: inline-flex;
   align-items: center;
   justify-content: center;
   transition: all .18s;

   &::after {
      content: '';
      width: 4px;
      height: 8px;
      margin-bottom: 2px;
      margin-left: 0.5px;
      border-right: 2px solid #FFFFFF;
      border-bottom: 2px solid #FFFFFF;
      transform: rotate(45deg);
      opacity: ${p => p.$checked ? 1 : 0};
      transition: opacity .15s;
   }
`;

const FooterBar = styled.div`
   display: flex;
   align-items: center;
   gap: 10px;
   padding: 12px 16px;
   border-top: 1px solid #F5F5F6;
   font-size: 12px;
   color: #B3B3B6;
   letter-spacing: -0.025em;
   background: #FFFFFF;
`;

export {
   Box,
   FooterBar, HiddenCheckbox, OptionRow, PopWrap,
   SearchBar,
   SearchInput,
   SectionBlock,
   SectionTitle
};
